import { createApp } from 'vue';

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'

// window 전역 접근을 위한 설정입니다.
declare global {
  interface Window {
    vm: any;
  }
}

window.vm = {};

createApp(App)
.use(router)
.use(store)
.mount('#app');